(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const reveal = root => {
    const items = root.querySelectorAll('[data-ns-reveal]:not(.is-visible)');
    if (reduced.matches || !('IntersectionObserver' in window)) {
      items.forEach(item => item.classList.add('is-visible'));
      return;
    }
    document.documentElement.classList.add('ns-motion');
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: .08 });
    items.forEach(item => observer.observe(item));
  };
  reveal(document);
  document.addEventListener('shopify:section:load', event => reveal(event.target));
  reduced.addEventListener('change', () => {
    if (reduced.matches) document.querySelectorAll('[data-ns-reveal]').forEach(item => item.classList.add('is-visible'));
  });
})();
